export default "__VITE_ASSET__BDC0nwbc__"